export default "__VITE_ASSET__CarN$K33__"